import {prettyError, prettyLog, prettyWarn} from './LogUtils';

export async function registerServiceWorkerAsync() {
    prettyLog('PwaUtils', 'Registering service worker');

    if (!('serviceWorker' in navigator)) {
        prettyWarn('PwaUtils', 'Service workers not supported in this browser');
        return;
    }

    prettyLog('PwaUtils', 'Service worker supported, registering...');

    try {
        const registration = await navigator.serviceWorker.register('/service-worker.js');

        if (registration.installing) prettyLog('service-worker', 'installing', registration);
        else if (registration.waiting) prettyLog('service-worker', 'waiting', registration);
        else if (registration.active) prettyLog('service-worker', 'active', registration);

        const serviceWorker =
            registration.installing || registration.waiting || registration.active;

        if (serviceWorker) {
            prettyLog(
                'service-sorker',
                'SS state:',
                serviceWorker.state,
                'SW scope:',
                registration.scope
            );
            serviceWorker.addEventListener('statechange', e => {
                prettyLog('service-worker', 'statechange:', (e.target as ServiceWorker).state);
            });
        }
    } catch (err) {
        prettyError('PwaUtils', 'Service worker registration failed:', err);
    }
}
